import { render, staticRenderFns } from "./link-carousel.vue?vue&type=template&id=3c1b8e02&scoped=true&"
import script from "./link-carousel.vue?vue&type=script&lang=js&"
export * from "./link-carousel.vue?vue&type=script&lang=js&"
import style0 from "./link-carousel.vue?vue&type=style&index=0&id=3c1b8e02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1b8e02",
  null
  
)

export default component.exports